module.exports = __webpack_public_path__ + "static/media/landing.3c00657e.svg";